import { type EmailTemplate } from "@repo/api";

export const DIRTY_AND_VALIDATE = {
  shouldDirty: true,
  shouldValidate: true,
} as const;

export const loadTemplateContent = (
  template: EmailTemplate,
  language: string,
  fallbackLanguage?: string
) => {
  const findTranslation = (
    translations: { language_key: string; translation: string }[] | undefined,
    base: string | undefined
  ) =>
    translations?.find((t) => t.language_key === language)?.translation ||
    (fallbackLanguage
      ? translations?.find((t) => t.language_key === fallbackLanguage)
          ?.translation
      : undefined) ||
    base ||
    "";

  return {
    subject: findTranslation(template.subject_translation, template.subject),
    body: findTranslation(
      template.text_formatter_translation,
      template.text_formatter
    ),
  };
};

export const getDraftKey = (opportunityId: number) =>
  `communication:draft:${opportunityId}`;
